import { gql } from 'graphql-request'

export const UPDATE_SENDGRID_SUBSCRIPTION_MUTATION = gql`
  mutation updateSendgridSubscription($email: String!, $shouldUnsubscribe: Boolean) {
    updateSendgridSubscription(email: $email, shouldUnsubscribe: $shouldUnsubscribe) {
      ok
    }
  }
`

export const UNSUBSCRIBE_HUBSPOT_MUTATION = gql`
  mutation unsubscribeHubspot($email: String!) {
    unsubscribeHubspot(email: $email) {
      ok
    }
  }
`

// WhiteLabel domains

export const CREATE_REDIRECT_SUBDOMAIN = gql`
  mutation createRedirectSubdomain($subdomain: String!, $rootDomainId: String!) {
    createRedirectSubdomain(subdomain: $subdomain, rootDomainId: $rootDomainId) {
      ok
      redirectSubdomain {
        id
        domain
        timestamp
        isVerified
      }
    }
  }
`

export const DELETE_REDIRECT_SUBDOMAIN = gql`
  mutation deleteRedirectSubdomain($subdomainId: String!) {
    deleteRedirectSubdomain(subdomainId: $subdomainId) {
      ok
    }
  }
`

export const RESTORE_REDIRECT_SUBDOMAIN = gql`
  mutation restoreRedirectSubdomain($subdomainId: String!) {
    restoreRedirectSubdomain(subdomainId: $subdomainId) {
      ok
    }
  }
`

export const REFRESH_REDIRECT_SUBDOMAIN_STATUS = gql`
  mutation refreshRedirectSubdomainStatus($subdomainId: String!) {
    refreshRedirectSubdomainStatus(subdomainId: $subdomainId) {
      isActive
    }
  }
`

export const CREATE_EXTERNAL_DOMAIN = gql`
  mutation createExternalDomain($domain: String!) {
    createExternalDomain(domain: $domain) {
      ok
      externalDomain {
        deletedAt
        domain
        id
        isCoBranded
        isVerified
        productType
        timestamp
      }
    }
  }
`

export const DELETE_EXTERNAL_DOMAIN = gql`
  mutation deleteExternalDomain($domainId: String!) {
    deleteExternalDomain(domainId: $domainId) {
      ok
    }
  }
`

export const SHARE_CODE_SUBDOMAIN = gql`
  mutation shareIthacaAssets(
    $assetType: String!
    $assetIds: [UUID!]!
    $entityPermissions: [EntityPermissionInputType]!
  ) {
    shareIthacaAssets(
      assetType: $assetType
      assetIds: $assetIds
      entityPermissions: $entityPermissions
    ) {
      assetPermissions {
        assetId
        result {
          success
          error
        }
      }
    }
  }
`

export const UNSHARE_CODE_SUBDOMAIN = gql`
  mutation unshareIthacaAssets($assetType: String!, $assetIds: [UUID]!, $entityIds: [UUID]!) {
    unshareIthacaAssets(assetType: $assetType, assetIds: $assetIds, entityIds: $entityIds) {
      assetPermissions {
        assetId
        result {
          success
          error
        }
      }
    }
  }
`

export const TRANSFER_FOLDER_MUTATION = gql`
  mutation transferDirectory($directoryId: ID!, $newOwnerEmail: String!) {
    transferDirectory(directoryId: $directoryId, newOwnerEmail: $newOwnerEmail) {
      ok
    }
  }
`

export const SAVE_CODE_TEMPLATE = gql`
  mutation saveCodeTemplate($input: BatchDesignTemplateInputType) {
    createBatchDesignTemplate(input: $input) {
      ok
      batchTemplate {
        id
        name
      }
    }
  }
`

export const DELETE_CODE_TEMPLATE = gql`
  mutation deleteCodeTemplate($templateId: ID!) {
    deleteBatchDesignTemplate(templateId: $templateId) {
      ok
    }
  }
`
